import RestRequest from "../tool/RestRequest";
import config from "../config";

export default class CookieService {
    static setCookieWithServer(key, value) {
        let fd = new FormData();
        fd.append('key', key);
        fd.append('value', value);

        return RestRequest.post(`${config.restCookie}`, {
            body: fd
        });
    }

    static destroy(key) {
        return RestRequest.delete(`${config.restCookie}`, key);
    }
}